<template>
    <el-row class="webhome-wrapper">
        <el-col :span="24" class="home-header">
            <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
                <div style="line-height: 50px;text-align: center;font-weight: bolder;font-size: large">Zoom BackService</div>
            </el-col>
            <el-col :xs="1" :span="10" class="title">
                <div class="tools" @click.prevent="collapse">
                    <i :class="collapsed?'el-icon-s-unfold':'el-icon-s-fold'"></i>
                </div>
                <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-inner">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <template v-for="item in $route.matched">
                        <el-breadcrumb-item :key="item.path" v-if="item.name">
                            {{ item.name }}
                        </el-breadcrumb-item>
                    </template>
                </el-breadcrumb>
            </el-col>
            <div class="userinfo ">
                <div class="userinfo-image"></div>
                <div class="userinfo-name">您好,{{user.name}} | <a href="#" @click.prevent="logout"> 登出</a></div>
            </div>

        </el-col>
        <el-col :span="24" class="main">
            <aside :class="collapsed?'menu-collapsed':'menu-expanded'" style="overflow-y: auto">
                <!--导航菜单-->
                <el-menu
                        :default-active="$route.path"
                        class="el-menu-vertical-dark"
                        :collapse="collapsed"
                        unique-opened router
                >
                    <template v-for="(item) in menu">
                        <el-submenu :index="item.name" v-if="item.children" :key="item.name">
                            <template slot="title"><i :class="item.icon"></i>
                                <span slot="title">{{item.name}}</span>
                            </template>
                            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.name">
                                <i v-if="child.icon" :class="child.icon"></i><span slot="title">{{child.name}}</span>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="!item.children" :index="item.path" :key="item.name">
                            <i :class="item.icon"></i>
                            <span slot="title">{{item.name}}</span>
                        </el-menu-item>
                    </template>
                </el-menu>

            </aside>
            <section class="content-container">
                <div class="grid-content bg-purple-light">
                    <el-col :span="24" class="breadcrumb-container">
                        <div class="d-flex justify-content-between">
                        <strong class="title">{{$route.name}}</strong>
                        </div>
                    </el-col>
                    <el-col :span="24" class="content-wrapper">
                        <keep-alive>
                            <router-view :key="pageKey" v-if="$route.meta && $route.meta.keepAlive"></router-view>
                        </keep-alive>
                        <router-view :key="pageKey" v-if="!($route.meta && $route.meta.keepAlive)"></router-view>
                    </el-col>
                </div>
            </section>
        </el-col>

    </el-row>
</template>

<script>

    import Home from "../router/home";
    import {mapState, mapMutations} from "vuex";

    export default {
        components: {},
        data() {
            return {
                collapsed: false,
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: '',
                },
            }
        },
        computed: {
            ...mapState(['user','preset']),
            logo(){
                if (this.$organization.org === 'publics' && this.user.logo)  return this.user.logo;
                return '/assets/' + this.$organization.org + '/images/logo.png';
            },
            menu() {
                let menu = [];
                const vm = this;
                const level = parseInt(this.user.role_level);
                Home.forEach(function (item) {
                    let can = true;
                    if (item.meta && item.meta.level) { //判断级别够不够
                        can = item.meta.level.indexOf(level) >= 0;
                        if (!can && item.meta.position) {
                            can = (vm.user.position == item.meta.position);
                        }
                    }
                    if (!item.hidden && can) {
                        const children = item.children;
                        if (children.length > 1) {  // 多个子项
                            let sub_menu = [];
                            children.forEach(function (child) {
                                let can = true;
                                if (child.meta && child.meta.level) { //子项也有权限
                                    can = child.meta.level.indexOf(level) >= 0;
                                }
                                if (child.meta && child.meta.mobile) { // 仅仅在手机端显示
                                    can = false;
                                }
                                if (child.meta && child.meta.public && vm.$organization.org !== 'publics') { //共享客户端
                                    can = false;
                                }
                                if (can && !(child.meta && child.meta.hidden)) { //子项隐藏
                                    sub_menu.push(child);
                                }
                            });
                            menu.push({icon: item.icon, name: item.name, children: sub_menu});

                        } else if (children.length === 1) { //单个子目录
                            const child = children[0];
                            menu.push(Object.assign({icon: item.icon, children: false}, child))
                        }
                    }
                });
                return menu;
            },
            pageKey() {
                if (this.$route.meta) {
                    if (this.$route.meta.model) return this.$route.meta.model;
                    else return this.$route.name;
                }
                return '';
            }
        },
        methods: {
            ...mapMutations('user', ['clear']),
            logout: function () { //退出登录
                this.$confirm('&nbsp;&nbsp;将要退出系统, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    dangerouslyUseHTMLString: true

                }).then(() => {
                    this.clear();
                    this.$router.replace('/sign-in');
                }).catch(() => {
                });
            },
            //折叠导航栏
            collapse: function () {
                this.collapsed = !this.collapsed;
            },
        },
        mounted() {
            if (window.innerWidth < 400) this.collapsed = true;
        },

    }

</script>

<style lang="scss">
    $color-header: #cfd8dc;
    $color-aside: #373e3e;
    $color-logo: #7f3626;
    $color-scrollbar: #5e3f3f;
    $color-title:red;

    .webhome-wrapper {
        height: 100%;

        .home-header {
            height: 49px;
            background: $color-header;
            //background: url("../assets/images/mybg.png") cornsilk;
            box-shadow: 0 2px 2px rgba(0, 0, 0, .05), 0 1px 0 rgba(0, 0, 0, .05);
            color: #fff;

            display: block;
            margin: 0;
            padding: 0 13px 0 0;
            position: relative;
            z-index: 905;
            overflow: hidden;

            .title {
                display: inline-block;
                vertical-align: middle;
                height: 49px;
                float: left;
                padding-left: 20px;
            }

            .usermanual {
                float: right;

                .words {
                    padding: 13px 20px;
                    min-width: 50px;
                    background-color: rgba(0, 0, 0, 0.05);
                    margin: 0 25px;
                    height: 49px;
                    cursor: pointer;
                    transition: all 0.2s ease-in;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.15);
                    }
                }
            }

            .userinfo {
                text-align: right;
                padding-right: 5px;
                float: right;

                .userinfo-image {
                    cursor: pointer;
                    display: inline-block;
                    overflow: hidden;
                    width: 30px;
                    height: 30px;
                    margin-top: 10px;
                    border-radius: 100px;

                    background: url("../assets/images/avatar.png") no-repeat center top;
                    background-size: cover;
                }

                .userinfo-name {
                    display: inline-block;
                    color: #606266;
                    line-height: 49px;
                    font-size: 13px;
                    float: right;
                    margin-left: 10px;
                }
            }

            .logo {
                height: 49px;
                font-size: 14px;
                background-color: $color-logo;
                color: #fff;
                position: relative;
                transition: all 0.2s ease-in;


                img {
                    max-width: 100%;
                    float: left;
                }
            }

            .logo-width {
                width: 229px;
            }

            .logo-collapse-width {
                width: 63px;
            }

            @media screen and (max-width: 400px) {
                .logo-collapse-width {
                    width: 0;
                }
            }

            .title {
                .tools {
                    float: left;
                    height: 49px;
                    line-height: 53px;
                    cursor: pointer;
                    margin-left: -10px;
                    margin-right: 10px;

                    i {
                        color: $color-logo;
                        font-size: 20px;

                        &:hover {
                            color: lighten($color-logo,30%);
                        }
                    }
                }

                .breadcrumb-inner {
                    line-height: 49px;
                }
            }
        }

        .main {
            display: flex;

            position: absolute;
            top: 49px;
            bottom: 0;
            overflow: hidden;

            aside {
                flex: 0 0 230px;
                width: 230px;
                display: block;
                background-color: $color-aside;
                overflow-y: auto;
                overflow-x: hidden;
                transition: all 0.2s ease-in;
                -webkit-overflow-scrolling: touch;
                min-height: 100%;

                &::-webkit-scrollbar {
                    width: 8px;
                    background-color: $color-scrollbar;
                }

                &::-webkit-scrollbar-thumb {
                    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
                    border-radius: 10px;
                    background-color: lighten($color-scrollbar, 20%);
                }

                .el-menu {
                    height: 100%;
                }

                .collapsed {
                    width: 64px;

                    .item {
                        position: relative;
                    }

                    .submenu {
                        position: absolute;
                        top: 0;
                        left: 64px;
                        z-index: 99999;
                        height: auto;
                        display: none;
                    }

                }
            }


            .menu-collapsed {
                flex: 0 0 64px;
                width: 64px;
            }

            @media screen and (max-width: 400px) {
                .menu-collapsed {
                    flex: 0 0 0;
                    width: 0;
                }
            }

            .menu-expanded {
                flex: 0 0 230px;
                width: 230px;
            }

            .content-container {
                flex: 1;
                overflow-y: auto;
                padding: 20px;
                -webkit-overflow-scrolling: touch;


                .breadcrumb-container {
                    //margin-bottom: 15px;
                    .title {
                        width: 200px;
                        float: left;
                        color: #475669;
                        font-size: 20px;
                    }
                }

                .content-wrapper {
                    box-sizing: border-box;
                    padding-top: 20px;
                }
            }
        }
    }

    .el-menu-vertical-dark {
        &.el-menu {
            background-color: $color-aside;

            .el-submenu__title:hover {
                background-color: lighten($color-aside,10%);
                color: white;
                font-weight: bold;

                i {
                    color: white;
                    font-weight: bold;
                }
            }

            .el-submenu__title {
                color: #dde1ec;
                i {
                    color: #bbc0cf;
                }
            }

            .el-menu-item {
                color: #dde1ec;
                i {
                    color: #bbc0cf;
                }

                &.is-active {
                    color: yellow;
                    i {
                        color: yellow;
                    }
                }

                &:focus {
                    background-color: rgba(255, 255, 255, 0.2);
                }
            }

            .el-menu-item:hover {
                background-color: lighten($color-aside,5%);
                color: lightgoldenrodyellow;
                font-weight: bold;
                i {
                    color: white;
                    font-weight: bold;
                }
            }

            .el-submenu .el-menu {
                background-color: darken($color-aside,5%);
            }
        }

        &:not(.el-menu--collapse) {
            width: 230px;
        }
    }

</style>
